module.exports = __webpack_public_path__ + "static/media/Creditcard.6552026b.png";